import {
  ButtonComponent, ButtonStyle,
} from '~/_shared/baseComponents/buttons';
import { ModalComponent } from '~/_shared/components/modal/modal.component';
import { useIntercom } from '~/_shared/utils/3rdPartyIntegrations/intercom/intercom.context';
import { useTranslation } from '~/_shared/utils/hooks';
import type { ModalProps } from '~/modal/modalType.enum';

export type PurchaseDataPackageProps = ModalProps<{
  type: PurchaseDataPackageType;
}>;

export enum PurchaseDataPackageType {
  DataLayer = 'DataLayer',
  ExportReport = 'ExportReport',
}

export const PurchaseDataPackageModalComponent = ({ isOpen, onClose, type }: PurchaseDataPackageProps) => {
  const { showNewMessage } = useIntercom();
  const [t] = useTranslation();

  const onContactButtonClick = () => {
    const messagePrefix = t('purchaseDataPackage.modal.contactMessagePrefix');
    const messagePackage = type === PurchaseDataPackageType.DataLayer ? t('purchaseDataPackage.modal.contactMessageAgsPackage') : t('purchaseDataPackage.modal.contactMessageExportReportPackage');
    const messageSuffix = t('purchaseDataPackage.modal.contactMessageSuffix');

    showNewMessage([messagePrefix, messagePackage, messageSuffix].join('\n\n'));
  };

  return (
    <ModalComponent
      isOpen={isOpen}
      onClose={onClose}
      caption={t('purchaseDataPackage.modal.title')}
      confirmButton={(
        <ButtonComponent
          text={t('purchaseDataPackage.modal.contactButtonLabel')}
          onClick={onContactButtonClick}
          buttonStyle={ButtonStyle.Success}
        />
      )}
    >
      <p>{t('purchaseDataPackage.modal.description1')}</p>
      <p>{t('purchaseDataPackage.modal.description2')}</p>
      <p>{t('purchaseDataPackage.modal.description3')}</p>
    </ModalComponent>
  );
};
